(function() {
  var zoneFraction = 0.35;

  function updateParallaxHalf() {
    var maxScroll = document.documentElement.scrollHeight - window.innerHeight;
    if (maxScroll <= 0) {
      document.body.style.setProperty('--parallax-first-opacity', '1');
      document.body.classList.remove('parallax-past-half');
      return;
    }
    var threshold = maxScroll * 0.65;
    var scrollY = window.scrollY;
    document.body.classList.toggle('parallax-past-half', scrollY > threshold);

    var zoneSize = maxScroll * zoneFraction;
    var zoneStart = threshold - zoneSize * 0.5;
    var zoneEnd = threshold + zoneSize * 0.5;
    var opacity = 1;
    if (scrollY <= zoneStart) {
      opacity = 1;
    } else if (scrollY >= zoneEnd) {
      opacity = 0;
    } else {
      var t = (scrollY - zoneStart) / (zoneEnd - zoneStart);
      t = t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
      opacity = 1 - t;
    }
    document.body.style.setProperty('--parallax-first-opacity', String(opacity));
  }

  updateParallaxHalf();
  window.addEventListener('scroll', updateParallaxHalf, { passive: true });
  window.addEventListener('resize', updateParallaxHalf);
})();
